import {
  Avatar,
  Button,
  Card,
  Divider,
  Form,
  Image,
  Input,
  InputNumber,
  List,
  message,
  Tabs,
  Tag,
  Modal,
  Tooltip,
  Badge,
  Skeleton,
  Carousel
} from 'antd'
import React, { useState, useEffect, useMemo } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import ProductImages from './ProductImages'
import { StarOutlined } from '@ant-design/icons'
// import ProductInfoItem from "../ProductInfoItem";
import {
  KeyOutlined,
  FilePdfOutlined,
  AndroidOutlined,
  RetweetOutlined,
  CommentOutlined,
  CarOutlined,
  ShoppingCartOutlined,
  UpOutlined,
  RotateLeftOutlined,
  YoutubeOutlined
} from '@ant-design/icons'
import ProductDocuments from './ProductDocuments'
import ApplicationList from './ApplicationList'
import ProductOEMList from './ProductOEMList'
import ProductDescription from './ProductDescription'
import VehiclePartsArea from '@/components/assistant/VehiclePartsArea/VehiclePartsArea'
import { useDispatch, useSelector } from 'react-redux'

import { setSiteSettings } from '@/store/settings'
import { useTranslation } from 'react-i18next'
import ProductBuyComponent from '@/components/products/BuyArea/BuyComponent'
// import useIsAddedBasketProduct from "@/hooks/useIsAddedBasketProduct";
import { LikeOutlined } from '@ant-design/icons';

import ReactJson from 'react-json-view'
import getCatalogName from '@/helpers/getCatalogName'
import ApplicationListTecdoc from './ApplicationListTecdoc'
import ProductLinksComponent from './ProductLinksComponent'
import RotateImage from './RotateImage'

import CopyIcon from '../icons/CopyIcon'
import CrossIcon from '../icons/CrossIcon'
import NotificationIcon from '../icons/NotificationIcon'
import DimensionalIcon from '../icons/DimensionalIcon'
import YoutubeIcon from '../icons/YoutubeIcon'
import DocumentIcon from '../icons/DocumentIcon'
import CarIcon from '../icons/CarIcon'
import OemIcon from '../icons/OemIcon'
import BuyAreav2 from './BuyAreav2/BuyAreav2'
import OtherSellers from './BuyAreav2/OtherSellers'
import { getFastestAvability, getOtherSeller } from '@/core/avability/avability2'
import SubPartsIcon from '../icons/SubPartsIcon'
import useCurrencyWithCode from '@/hooks/useCurrencyWithCode'

function findDeposits(data) {
  try {
    // Eğer bir geçerli deposit bulunursa onu döner
    for (let item of data?.data || []) {
      let depositValue = item.deposit;
      // Eğer deposit değeri sayısal olarak geçerli ise direkt döneriz
      if (!isNaN(depositValue)) {
        console.log("is return", Number(parseFloat(depositValue).toFixed(2)));
        return Number(parseFloat(depositValue).toFixed(2));
      }
    }

    return 0; // Eğer hiç geçerli bir deposit bulunmazsa 0 döner
  } catch (e) {
    return 0; // Hata durumunda 0 döner
  }
}



const RecommendedIcon = (props) => (
  <svg
    width={121}
    height={34}
    viewBox="0 0 121 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.192.894a3.34 3.34 0 0 0-4.44 1.359 3.34 3.34 0 0 1-2.4 1.683 3.34 3.34 0 0 0-2.793 3.708 3.34 3.34 0 0 1-.954 2.773 3.34 3.34 0 0 0-.08 4.642 3.34 3.34 0 0 1 .86 2.804 3.34 3.34 0 0 0 2.663 3.802 3.34 3.34 0 0 1 2.343 1.764 3.34 3.34 0 0 0 4.39 1.51 3.34 3.34 0 0 1 2.932.05 3.34 3.34 0 0 0 4.44-1.36 3.34 3.34 0 0 1 2.4-1.682 3.34 3.34 0 0 0 2.793-3.709 3.34 3.34 0 0 1 .954-2.773 3.34 3.34 0 0 0 .079-4.642 3.34 3.34 0 0 1-.858-2.803 3.34 3.34 0 0 0-2.665-3.802 3.34 3.34 0 0 1-2.342-1.764 3.34 3.34 0 0 0-4.39-1.51 3.34 3.34 0 0 1-2.932-.05m1.278 22.292c5.623 0 10.18-4.558 10.18-10.18 0-5.623-4.557-10.181-10.18-10.181S3.29 7.383 3.29 13.005c0 5.623 4.558 10.18 10.18 10.18"
      fill={props.color || "#333"}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.97 23.38c.406.303.744.698.98 1.162a3.34 3.34 0 0 0 4.39 1.51q.224-.105.458-.174l-2.543 7.071a.447.447 0 0 1-.816.056 3.575 3.575 0 0 0-4.547-1.635.447.447 0 0 1-.593-.563zm14.584 0a3.34 3.34 0 0 0-.98 1.162 3.34 3.34 0 0 1-4.39 1.51 3.4 3.4 0 0 0-.458-.174l2.543 7.071c.131.366.635.4.816.056a3.575 3.575 0 0 1 4.547-1.635.447.447 0 0 0 .593-.563zm-7.084-1.355a9.02 9.02 0 1 0 0-18.04 9.02 9.02 0 0 0 0 18.04m4.394-11.21a.422.422 0 0 0-.614-.578l-4.275 4.538-1.978-1.96a.422.422 0 1 0-.594.6l2.285 2.264a.42.42 0 0 0 .605-.01zm96.762 10.965h-90.55a3.29 3.29 0 0 0 1.254-2.939l-.044-.398a3.72 3.72 0 0 1 .93-2.87c1.197-1.338 1.275-3.345.181-4.655l-.15-.18c-.656-.785-.944-1.839-.794-2.9l.035-.244c.199-1.4-.427-2.702-1.52-3.363h90.658a6 6 0 0 1 6 6v5.549a6 6 0 0 1-6 6M28.802 8.388v9.207h1.389V14.11h1.978l1.87 3.485h1.582l-2.037-3.721a3 3 0 0 0 .27-.119 2.4 2.4 0 0 0 1.061-.993q.356-.644.356-1.488 0-.85-.351-1.497a2.44 2.44 0 0 0-1.061-1.02q-.705-.37-1.776-.37zm1.389 4.527h1.762q.674 0 1.097-.194a1.28 1.28 0 0 0 .625-.562q.198-.367.198-.885 0-.523-.203-.904a1.3 1.3 0 0 0-.625-.584q-.422-.207-1.11-.207H30.19zm67.281 4.387q.656.427 1.493.427.629 0 1.025-.211.395-.21.62-.495.23-.282.351-.503h.112v1.075h1.313V8.388h-1.344v3.42h-.081a4 4 0 0 0-.342-.498 1.85 1.85 0 0 0-.611-.495q-.392-.216-1.034-.216-.832 0-1.488.423-.657.423-1.034 1.218-.374.796-.373 1.915 0 1.12.368 1.92.373.796 1.025 1.227m2.769-1.025q-.4.306-.98.306-.597 0-1.007-.32a2 2 0 0 1-.611-.876 3.5 3.5 0 0 1-.207-1.245q0-.684.202-1.227.207-.545.612-.86t1.011-.314q.59 0 .989.302.4.3.607.84t.207 1.259q0 .728-.211 1.277a1.9 1.9 0 0 1-.612.858m14.078 1.452a2.67 2.67 0 0 1-1.492-.427q-.653-.431-1.025-1.227-.369-.8-.369-1.92t.373-1.915q.378-.795 1.034-1.218a2.7 2.7 0 0 1 1.488-.423q.643 0 1.034.216.396.211.612.495.22.283.341.499h.081V8.388h1.344v9.207h-1.312V16.52h-.113a3.6 3.6 0 0 1-.35.503 1.95 1.95 0 0 1-.621.495q-.395.21-1.025.211m.297-1.146q.58 0 .98-.306a1.9 1.9 0 0 0 .611-.858q.212-.55.212-1.277 0-.72-.207-1.259-.207-.54-.607-.84-.4-.302-.989-.302-.607 0-1.012.315a1.93 1.93 0 0 0-.611.859 3.5 3.5 0 0 0-.202 1.227q0 .692.207 1.245.206.553.611.877.409.32 1.007.319m-7.336 1.15q-1.02 0-1.757-.435a2.95 2.95 0 0 1-1.133-1.236q-.396-.801-.396-1.875 0-1.06.396-1.87.4-.809 1.115-1.264.719-.454 1.681-.454.584 0 1.133.194.548.192.984.607.436.412.688 1.074.252.657.252 1.596v.476h-4.908q.015.632.241 1.084.248.485.688.742.44.252 1.03.251.382 0 .697-.108.314-.111.544-.332.228-.22.35-.544l1.272.23a2.3 2.3 0 0 1-.548.984 2.66 2.66 0 0 1-.985.651q-.588.23-1.344.23m-1.721-5.025a2 2 0 0 0-.222.832h3.589q0-.53-.216-.94a1.63 1.63 0 0 0-.607-.652 1.7 1.7 0 0 0-.908-.238q-.566 0-.989.278a1.86 1.86 0 0 0-.647.72m-15.401.787v4.1h-1.344V10.69h1.29v1.124h.085q.24-.55.747-.88.512-.334 1.29-.334.706 0 1.236.297.53.293.823.872.292.58.292 1.434v4.393h-1.344v-4.23q0-.752-.391-1.174-.392-.427-1.075-.427-.467 0-.831.202-.36.203-.571.593-.207.387-.207.936m-7.556 3.803q.737.435 1.758.436.754 0 1.344-.23.594-.233.984-.651.396-.423.549-.985l-1.272-.23a1.45 1.45 0 0 1-.895.877q-.315.108-.697.108a2.04 2.04 0 0 1-1.03-.251 1.76 1.76 0 0 1-.687-.742q-.225-.453-.242-1.084h4.908v-.476q0-.939-.251-1.596a2.85 2.85 0 0 0-.688-1.074 2.7 2.7 0 0 0-.985-.607 3.4 3.4 0 0 0-1.133-.194q-.961 0-1.681.454a3.07 3.07 0 0 0-1.115 1.264q-.395.809-.395 1.87 0 1.074.395 1.874.4.796 1.133 1.237m-.185-3.758h3.588q0-.53-.216-.94a1.63 1.63 0 0 0-.607-.652 1.7 1.7 0 0 0-.908-.238q-.566 0-.989.278a1.87 1.87 0 0 0-.647.72 2.05 2.05 0 0 0-.221.832m-12.222 4.055V10.69h1.29v1.124h.086q.216-.57.706-.89.49-.324 1.173-.324.692 0 1.16.324.472.324.697.89h.072q.248-.553.786-.88.54-.334 1.286-.334.94 0 1.533.59.598.588.598 1.775v4.63h-1.344V13.09q0-.702-.382-1.016a1.4 1.4 0 0 0-.913-.315q-.656 0-1.02.405-.364.4-.364 1.03v4.4h-1.34v-4.59q0-.561-.35-.903-.352-.342-.913-.342-.382 0-.706.202a1.5 1.5 0 0 0-.517.553 1.7 1.7 0 0 0-.193.823v4.258zM59.007 10.69v6.906h1.344v-4.258q0-.468.194-.822.197-.356.517-.554.323-.202.705-.202.563 0 .913.342t.35.903v4.59h1.34v-4.4q0-.63.364-1.03.364-.405 1.02-.405.532 0 .913.315.383.315.383 1.016v4.505h1.344v-4.631q0-1.187-.598-1.776-.594-.588-1.533-.589-.747 0-1.286.333-.54.328-.787.881h-.072a1.9 1.9 0 0 0-.696-.89q-.468-.324-1.16-.324-.684 0-1.173.324-.49.32-.706.89h-.086V10.69zm-4.72 7.045q-.97 0-1.694-.445a3 3 0 0 1-1.124-1.245q-.4-.8-.4-1.87 0-1.075.4-1.88a3 3 0 0 1 1.124-1.25q.724-.445 1.695-.445.97 0 1.695.445.723.446 1.124 1.25.4.805.4 1.88 0 1.07-.4 1.87a3 3 0 0 1-1.124 1.245q-.724.444-1.695.445m.005-1.129q.63 0 1.043-.332.414-.333.612-.886.202-.553.202-1.218 0-.66-.202-1.214a2 2 0 0 0-.612-.895q-.413-.336-1.043-.337-.633 0-1.052.337a2 2 0 0 0-.616.895 3.6 3.6 0 0 0-.197 1.214q0 .665.197 1.218.202.553.616.886.42.332 1.052.332m-8.913.675q.724.453 1.726.454.818 0 1.425-.301.612-.302.976-.828.363-.526.436-1.195h-1.308a1.54 1.54 0 0 1-.302.638q-.21.265-.526.41a1.7 1.7 0 0 1-.692.138q-.57 0-.993-.3a1.94 1.94 0 0 1-.648-.85q-.23-.548-.229-1.304 0-.738.234-1.277.234-.544.652-.836a1.67 1.67 0 0 1 .984-.297q.643 0 1.025.35.387.352.495.837h1.308q-.073-.697-.454-1.218a2.5 2.5 0 0 0-.994-.81 3.2 3.2 0 0 0-1.402-.292q-.976 0-1.695.454a3.03 3.03 0 0 0-1.115 1.264q-.396.804-.396 1.856 0 1.039.387 1.844.387.804 1.106 1.263m-5.636.454q-1.02 0-1.758-.436a2.96 2.96 0 0 1-1.133-1.236q-.396-.801-.396-1.875 0-1.06.396-1.87.4-.809 1.115-1.264.72-.454 1.681-.454.585 0 1.133.194.549.192.985.607.436.412.687 1.074.252.657.252 1.596v.476h-4.908q.015.632.242 1.084.246.485.688.742a2.04 2.04 0 0 0 1.029.251q.382 0 .697-.108.314-.111.544-.332.23-.22.35-.544l1.273.23a2.3 2.3 0 0 1-.549.984q-.39.418-.984.651-.59.23-1.345.23m1.645-4.195h-3.589q.025-.445.222-.831.229-.446.647-.72.422-.278.99-.278.521 0 .907.238.391.238.607.652.216.41.216.94"
      fill={props.color || "#333"}
    />
  </svg>
);


const getDesc = (fastestAvability, language) => {
  let description = "";

  try {
    description = fastestAvability?.description && typeof fastestAvability.description === "object"
      ? fastestAvability.description[language?.toUpperCase()] || ""
      : "";

    if (description.length > 80) {
      description = description.slice(0, 80) + "...";
    }
  } catch (error) {
  }

  return description;
}

const Product = ({ product, Series, plate, onlyAvability = false, deliveries }) => {
  const isAddedBasket = false // useIsAddedBasketProduct({ uniqId: product.uniqId });

  const { t } = useTranslation()
  const [developer, setDeveloper] = useState(false)
  const [modalVisibles, setModalVisibles] = useState({ Documents: false, ApplicationList: false, Description: false, Oem: false, Parts: false })
  const settings = useSelector((e) => e.settings)
  const [devClicker, setDevClicker] = useState(0)
  const [loading, setLoading] = useState(false)
  const [avability, setAvability] = useState({})

  const catalogName = useMemo(() => getCatalogName(), [])

  const language = useSelector((e) => e.settings.Language)

  let deposit = findDeposits(product?.avability);



  const d = useDispatch()
  const onCopyHandler = () => {
    message.success('Copy to clipboard !')
    setDevClicker(devClicker + 1)
  }
  useEffect(() => {
    if (devClicker > 10) {
      d(
        setSiteSettings({
          type: 'developerMode',
          value: true
        })
      )
    }
  }, [devClicker])

  const [showOtherSellers, setShowOtherSellers] = useState(false)

  let remarks1,
    remarks2 = []
  if (Array.isArray(product.Remarks)) {
    const halfIndex = Math.ceil(product.Remarks.length / 2)
    remarks1 = product.Remarks.slice(0, halfIndex)
    remarks2 = product.Remarks.slice(halfIndex, product.Remarks.length)
  }

  const fastestAvability = getFastestAvability(product?.avability, deliveries)

  const otherSellers = getOtherSeller(product?.avability)


  const description = getDesc(fastestAvability, language);

  const isStar = product?.isStar


  return (
    <div className="w-full" style={{ display: onlyAvability == true && loading == false && avability.SaleStatus == false ? 'none' : '' }}>
      {product ? (
        <React.Fragment>
          <div className="w-full">
            <Modal
              width={'100%'}
              footer={null}
              title="Documents"
              open={modalVisibles.Documents}
              onCancel={() => setModalVisibles({ ...modalVisibles, Documents: false })}
            >
              <ProductDocuments Documents={product.Documents} />
            </Modal>

            <Modal
              width={'100%'}
              title="Application List"
              footer={null}
              open={modalVisibles.ApplicationList}
              onCancel={() => setModalVisibles({ ...modalVisibles, ApplicationList: false })}
            >
              {catalogName == 'TECDOC' ? (
                <ApplicationListTecdoc
                  onSelectVehicle={() => {
                    setModalVisibles({ ...modalVisibles, ApplicationList: false })
                  }}
                  reference={product.ProductReference}
                  brandId={product.CatalogBrandId}
                />
              ) : (
                <ApplicationList
                  onAddVehicle={() => setModalVisibles({ ...modalVisibles, ApplicationList: false })}
                  Series={Series}
                  reference={product.ProductReference}
                  brandId={product.CatalogBrandId}
                />
              )}
            </Modal>

            {/* <Modal footer={null} open={modalVisibles.Description} onCancel={() => setModalVisibles({ ...modalVisibles, Description: false })}>
                    <ProductDescriptionList  LinkRemarks={product.LinkRemarks ? product.LinkRemarks : []} Description={product.Description} />
                </Modal> */}

            <Modal footer={null} open={modalVisibles.Oem} onCancel={() => setModalVisibles({ ...modalVisibles, Oem: false })}>
              <ProductOEMList
                list={
                  product && product.AlternativeProductReference && product.AlternativeProductReference.OEM
                    ? product.AlternativeProductReference.OEM
                    : []
                }
              />
            </Modal>


            <Modal footer={null} open={modalVisibles.RotateImages} onCancel={() => setModalVisibles({ ...modalVisibles, RotateImages: false })}>
              <RotateImage links={product.RotateImages} />
            </Modal>

            <Modal footer={null} open={modalVisibles.Links} onCancel={() => setModalVisibles({ ...modalVisibles, Links: false })}>
              <ProductLinksComponent links={product.Links} />
            </Modal>

            <Modal width={'100%'} footer={null} open={modalVisibles.Parts} onCancel={() => setModalVisibles({ ...modalVisibles, Parts: false })}>
              <VehiclePartsArea productGroupId={product?.CatalogProductGroupId} plate={plate} productReference={product.ProductReference} />
            </Modal>


            {

              product?.subParts ?


                (
                  <Modal
                    width={'100%'}
                    footer={null}
                    open={modalVisibles.subParts}
                    onCancel={() => setModalVisibles({ ...modalVisibles, subParts: false })}
                  >
                    <VehiclePartsArea
                      productGroupId={product?.CatalogProductGroupId}
                      plate={plate}
                      series={Series}
                      catalogBrandId={product?.CatalogBrandId}
                      productReference={product.ProductReference}
                    />
                  </Modal>
                ) : null}

            <Modal width={'100%'} open={developer} onCancel={() => setDeveloper(false)}>
              <ReactJson src={product} />
            </Modal>

            <div className="mx-auto p-2.5 bg-white rounded-[6px] border border-neutral-200 gap-2.5 mb-[10px]">
              <div className=" w-full flex flex-wrap  justify-between mb-1  ">
                <div className="w-full flex flex-1   flex-wrap">

                  <div
                    className="w-full sm:w-1/2 md:w-1/5 p-[10px] flex relative justify-center"
                  >
                    {/* Like iconu */}
                    {product.isStar ? (
                      <div
                        style={{
                          position: "absolute",
                          top: "0",
                          left: "0",
                          color: settings?.['HeaderBgColor'],
                          fontSize: "20px",
                          zIndex: 10, // İkonun her zaman üstte görünmesi için
                        }}
                      >
                        {/* <LikeOutlined /> */}
                        <RecommendedIcon color={settings?.['HeaderBgColor']} />
                      </div>
                    ) : ''}

                    {product.Image.length > 0 ? (
                      <Image.PreviewGroup items={product.Image}>
                        <Carousel draggable className="w-[170px]" infinite={false}>
                          {product.Image.map((item, index) => {
                            return (
                              <Image
                                key={index}
                                className="w-full h-[170px] relative object-cover relative object-scale-down self-stretch grow shrink basis-0"
                                src={item}
                                style={{ width: "auto" }}
                              />
                            );
                          })}
                        </Carousel>
                      </Image.PreviewGroup>
                    ) : (
                      <div className="flex justify-center" style={{ width: "50%" }}>
                        <img
                          className="w-full h-[170px] relative object-cover relative object-scale-down self-stretch grow shrink basis-0"
                          alt="Image"
                          src="https://material.parts-soft.net/image.php?brandId=0&productreference=0"
                        />
                      </div>
                    )}
                  </div>




                  <div className="w-full sm:w-1/2 md:w-1/4 p-[10px] flex flex-col justify-between">
                    <div className="flex flex-col items-start gap-[5px] relative self-stretch w-full flex-[0_0_auto]">
                      <div className="inline-flex items-center gap-[5px] p-[3px] relative flex-[0_0_auto] bg-[#f6f7f9] rounded-[6px] overflow-hidden">
                        <div className="inline-flex flex-col items-start p-[3px] relative flex-[0_0_auto] bg-white rounded-[3px] overflow-hidden">
                          <img
                            className="w-full h-[15px] relative object-cover"
                            alt="Image"
                            src={`https://aksamlar.com/public/brands-aksamlar/${product?.BrandId}.png`}
                            onError={(e) => {
                              e.target.src = 'https://material.parts-soft.net/image.php?brandId=-1&productreference=-1'
                            }}
                          />

                        </div>
                        <div className="relative   [font-family:'Poppins-Medium',Helvetica] font-medium text-[#565d6ccc] text-[14px]">
                          {product?.BrandName}
                        </div>

                      </div>
                      <CopyToClipboard text={product?.ProductReference} onCopy={() => onCopyHandler()}>
                        <div className="flex items-center gap-[5px] relative self-stretch w-full flex-[0_0_auto] rounded-[4px] overflow-hidden">
                          <div
                            className="relative w-fit [font-family:'Poppins-Bold',Helvetica] font-bold text-[#eb7130] text-[20px] tracking-[0] leading-[normal] whitespace-nowrap cursor-pointer"
                            style={{ color: settings?.['HeaderBgColor'] }}
                          >
                            {product?.ProductReference}
                          </div>
                          <div className="inline-flex flex-col items-start p-[4px] relative flex-[0_0_auto] bg-[#f4f4f4] rounded-[6px] overflow-hidden cursor-pointer">
                            <CopyIcon className="w-[12px] h-[14px] top-[2px] left-0 -rotate-180" />
                          </div>
                        </div>
                      </CopyToClipboard>
                      <div className="flex items-start px-0 py-[5px] relative self-stretch w-full flex-[0_0_auto] rounded-[4px] relative w-fit [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c99] text-[16px] tracking-[0] leading-[normal] whitespace-nowrap overflow-hidden">
                        {product?.CatalogProductGroupName}
                      </div>
                      {/* <div className="flex items-start px-0 py-[5px] relative self-stretch w-full flex-[0_0_auto] rounded-[4px] relative w-fit [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c99] text-[16px] tracking-[0] leading-[normal] whitespace-nowrap overflow-hidden">

                  </div> */}

                      {product?.CommericalName && <Tag> {product?.CommericalName}</Tag>}

                      {product?.StatusCodeName && <Tag className="mb-1"> {product?.StatusCodeName}</Tag>}


                    </div>
                    <div className="flex gap-[5px] relative self-stretch flex-[0_0_auto] justify-start items-start gap-[5px] inline-flex">
                      <a
                        className="flex items-center justify-center p-[5px] relative self-stretch flex-[0_0_auto] rounded-[6px] border-[1px] border-solid border-[#f0f0f0]"
                        style={{ backgroundColor: `${settings['HeaderBgColor']}27` }}
                        onClick={() => setModalVisibles({ ...modalVisibles, Parts: true })}
                      >
                        <CrossIcon color={settings['HeaderBgColor']} />
                      </a>

                      <a className="flex items-center justify-center p-[5px] relative self-stretch flex-[0_0_auto] rounded-[6px] border-[1px] border-solid border-[#f0f0f0]">
                        <NotificationIcon />
                      </a>

                      {product?.RotateImages?.length ? (
                        <a
                          className="flex items-center justify-center p-[5px] relative self-stretch flex-[0_0_auto] rounded-[6px] border-[1px] border-solid border-[#f0f0f0]"
                          style={{ backgroundColor: `${settings['HeaderBgColor']}27` }}
                          onClick={() => setModalVisibles({ ...modalVisibles, RotateImages: true })}
                        >
                          <DimensionalIcon color={settings['HeaderBgColor']} />
                        </a>
                      ) : (
                        <a className="flex items-center justify-center p-[5px] relative self-stretch flex-[0_0_auto] rounded-[6px] border-[1px] border-solid border-[#f0f0f0]">
                          <DimensionalIcon />
                        </a>
                      )}

                      {product?.Links?.length ? (
                        <a
                          className="flex items-center justify-center p-[5px] relative self-stretch flex-[0_0_auto] rounded-[6px] border-[1px] border-solid border-[#f0f0f0]"
                          style={{ backgroundColor: `${settings['HeaderBgColor']}27` }}
                          onClick={() => setModalVisibles({ ...modalVisibles, Links: true })}
                        >
                          <YoutubeIcon color={settings['HeaderBgColor']} />
                        </a>
                      ) : (
                        <a className="flex items-center justify-center p-[5px] relative self-stretch flex-[0_0_auto] rounded-[6px] border-[1px] border-solid border-[#f0f0f0]">
                          <YoutubeIcon />
                        </a>
                      )}

                      {product.Documents && product.Documents.length ? (
                        <a
                          className="flex items-center justify-center p-[5px] relative self-stretch flex-[0_0_auto] rounded-[6px] border-[1px] border-solid border-[#f0f0f0]"
                          style={{ backgroundColor: `${settings['HeaderBgColor']}27` }}
                          onClick={() => setModalVisibles({ ...modalVisibles, Documents: true })}
                        >
                          <DocumentIcon color={settings['HeaderBgColor']} />
                        </a>
                      ) : (
                        <a className="flex items-center justify-center p-[5px] relative self-stretch flex-[0_0_auto] rounded-[6px] border-[1px] border-solid border-[#f0f0f0]">
                          <DocumentIcon />
                        </a>
                      )}

                      {/* {catalogName == 'ALDOC' && (
                        <a
                          className="flex items-center justify-center p-[5px] relative self-stretch flex-[0_0_auto] rounded-[6px] border-[1px] border-solid border-[#f0f0f0]"
                          style={{ backgroundColor: `${settings['HeaderBgColor']}27` }}
                          onClick={() => setModalVisibles({ ...modalVisibles, subParts: true })}
                        >
                          <SubPartsIcon color={settings['HeaderBgColor']} />
                        </a>
                      )} */}


                      {product?.subParts
                        ?
                        (
                          <a
                            className="flex items-center justify-center p-[5px] relative self-stretch flex-[0_0_auto] rounded-[6px] border-[1px] border-solid border-[#f0f0f0]"
                            style={{ backgroundColor: `${settings['HeaderBgColor']}27` }}
                            onClick={() => setModalVisibles({ ...modalVisibles, subParts: true })}
                          >
                            <SubPartsIcon color={settings['HeaderBgColor']} />
                          </a>
                        ) :
                        null

                      }









                      {product.CatalogBrandId ? (
                        <a
                          className="flex items-center justify-center p-[5px] relative self-stretch flex-[0_0_auto] rounded-[6px] border-[1px] border-solid border-[#f0f0f0]"
                          style={{ backgroundColor: `${settings['HeaderBgColor']}27` }}
                          onClick={() => setModalVisibles({ ...modalVisibles, ApplicationList: true })}
                        >
                          <CarIcon color={settings['HeaderBgColor']} />
                        </a>
                      ) : (
                        <a className="flex items-center justify-center p-[5px] relative self-stretch flex-[0_0_auto] rounded-[6px] border-[1px] border-solid border-[#f0f0f0]">
                          <CarIcon />
                        </a>
                      )}

                      <a
                        className="flex items-center justify-center p-[5px] relative self-stretch flex-[0_0_auto] rounded-[6px] border-[1px] border-solid border-[#f0f0f0]"
                        style={{ backgroundColor: `${settings['HeaderBgColor']}27` }}
                        onClick={() => setModalVisibles({ ...modalVisibles, Oem: true })}
                      >
                        <OemIcon color={settings['HeaderBgColor']} />
                      </a>

                      {settings['developerMode'] == true && (
                        <a
                          className="flex items-center justify-center p-[5px] relative self-stretch flex-[0_0_auto] rounded-[6px] border-[1px] border-solid border-[#f0f0f0]"
                          style={{ backgroundColor: `${settings['HeaderBgColor']}27` }}
                          onClick={() => setDeveloper(true)}
                        >
                          <AndroidOutlined />
                        </a>
                      )}
                    </div>
                  </div>

                  {Array.isArray(remarks1) && remarks1.length > 0 && (
                    <div className="w-full sm:w-1/2 md:w-1/4 p-[10px]">
                      {remarks1.map((item, index) => {
                        let remarks = item?.Remark.split(':')
                        return (
                          <div
                            className={`flex w-full items-start justify-between px-[5px] py-[5px] relative flex-[0_0_auto] ${index % 2 === 0 ? 'bg-[#f6f7f9]' : 'bg-white'
                              } rounded-[4px] overflow-hidden`}
                          >
                            <div className="relative w-fit [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                              {remarks?.[0]?.trim() || ''} :
                            </div>
                            <div className="relative w-fit [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                              {remarks?.[1]?.trim() || ''}
                            </div>
                          </div>
                        )
                      })}


                    </div>
                  )}

                  {Array.isArray(remarks2) && remarks2.length > 0 && (
                    <div className="w-full sm:w-1/2 md:w-1/4 p-[10px]">
                      {remarks2.map((item, index) => {
                        let remarks = item?.Remark.split(':')
                        return (
                          <div
                            className={`flex w-full items-start justify-between px-[5px] py-[5px] relative flex-[0_0_auto] ${index % 2 === 0 ? 'bg-[#f6f7f9]' : 'bg-white'
                              } rounded-[4px] overflow-hidden`}
                          >
                            <div className="relative w-fit [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                              {remarks?.[0]?.trim() || ''} :
                            </div>
                            <div className="relative w-fit [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                              {remarks?.[1]?.trim() || ''}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  )}

                  <Divider />

                  <div className="relative w-fit [font-family:'Poppins-Regular',Helvetica] font-normal text-[#565d6c] text-[12px] tracking-[0] leading-[normal]">
                    {description}
                  </div>

                </div>


                <div className={`w-full ${deposit ? 'max-h-[190px]' : 'max-h-[180px]'} sm:w-1/2 md:w-1/6 p-2 bg-neutral-100 rounded-md flex flex-col justify-between inline-flex flex-wrap`}>
                  <Skeleton active={true} loading={product?.loadingAvability}>
                    <BuyAreav2
                      externalInformation={{
                        Image: product.Image?.length ? product.Image[0] : null,
                        Category: product?.CatalogProductGroupName ? product?.CatalogProductGroupName : null
                      }}
                      deposit={deposit}
                      Plate={plate}
                      deliveries={deliveries}
                      otherSellers={otherSellers}
                      onClickOtherSellers={() => setShowOtherSellers(!showOtherSellers)}
                      fastestAvability={fastestAvability}
                    />
                  </Skeleton>
                </div>

              </div>
              <div className={`flex flex-col gap-[5px] w-full relative overflow-y-auto ${showOtherSellers ? '' : 'hidden'}`}>
                <OtherSellers otherSellers={otherSellers} />
              </div>
            </div>

          </div>
        </React.Fragment>
      ) : null}
    </div>
  )
}

export default React.memo(Product)
